/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TipoEquipamentoCriteriaDto } from '../models/tipo-equipamento-criteria-dto';
import { TipoEquipamentoDto } from '../models/tipo-equipamento-dto';
import { TipoEquipamentoFormDto } from '../models/tipo-equipamento-form-dto';
import { TipoEquipamentoPageDto } from '../models/tipo-equipamento-page-dto';


/**
 * Tipos de Equipamento
 */
@Injectable({
  providedIn: 'root',
})
export class TiposEquipamentoService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTiposEquipamento
   */
  static readonly GetTiposEquipamentoPath = '/tipos-equipamento';

  /**
   * Pesquisar tipos de equipamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTiposEquipamento()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposEquipamento$Response(params?: {
    criteria?: TipoEquipamentoCriteriaDto;
  }): Observable<StrictHttpResponse<TipoEquipamentoPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposEquipamentoService.GetTiposEquipamentoPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoEquipamentoPageDto>;
      })
    );
  }

  /**
   * Pesquisar tipos de equipamento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTiposEquipamento$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposEquipamento(params?: {
    criteria?: TipoEquipamentoCriteriaDto;
  }): Observable<TipoEquipamentoPageDto> {

    return this.getTiposEquipamento$Response(params).pipe(
      map((r: StrictHttpResponse<TipoEquipamentoPageDto>) => r.body as TipoEquipamentoPageDto)
    );
  }

  /**
   * Path part for operation createTipoEquipamento
   */
  static readonly CreateTipoEquipamentoPath = '/tipos-equipamento';

  /**
   * Criar tipo de equipamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTipoEquipamento()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoEquipamento$Response(params?: {

    /**
     * apiRequest
     */
    body?: TipoEquipamentoFormDto
  }): Observable<StrictHttpResponse<TipoEquipamentoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposEquipamentoService.CreateTipoEquipamentoPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoEquipamentoDto>;
      })
    );
  }

  /**
   * Criar tipo de equipamento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTipoEquipamento$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoEquipamento(params?: {

    /**
     * apiRequest
     */
    body?: TipoEquipamentoFormDto
  }): Observable<TipoEquipamentoDto> {

    return this.createTipoEquipamento$Response(params).pipe(
      map((r: StrictHttpResponse<TipoEquipamentoDto>) => r.body as TipoEquipamentoDto)
    );
  }

  /**
   * Path part for operation getTipoEquipamento
   */
  static readonly GetTipoEquipamentoPath = '/tipos-equipamento/{id}';

  /**
   * Obter tipo de equipamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTipoEquipamento()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoEquipamento$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoEquipamentoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposEquipamentoService.GetTipoEquipamentoPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoEquipamentoDto>;
      })
    );
  }

  /**
   * Obter tipo de equipamento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTipoEquipamento$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoEquipamento(params: {
    id: number;
  }): Observable<TipoEquipamentoDto> {

    return this.getTipoEquipamento$Response(params).pipe(
      map((r: StrictHttpResponse<TipoEquipamentoDto>) => r.body as TipoEquipamentoDto)
    );
  }

  /**
   * Path part for operation updateTipoEquipamento
   */
  static readonly UpdateTipoEquipamentoPath = '/tipos-equipamento/{id}';

  /**
   * Atualizar tipo de equipamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTipoEquipamento()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoEquipamento$Response(params: {
    id: number;
    body?: TipoEquipamentoFormDto
  }): Observable<StrictHttpResponse<TipoEquipamentoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposEquipamentoService.UpdateTipoEquipamentoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoEquipamentoDto>;
      })
    );
  }

  /**
   * Atualizar tipo de equipamento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTipoEquipamento$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoEquipamento(params: {
    id: number;
    body?: TipoEquipamentoFormDto
  }): Observable<TipoEquipamentoDto> {

    return this.updateTipoEquipamento$Response(params).pipe(
      map((r: StrictHttpResponse<TipoEquipamentoDto>) => r.body as TipoEquipamentoDto)
    );
  }

  /**
   * Path part for operation ativarTipoEquipamento
   */
  static readonly AtivarTipoEquipamentoPath = '/tipos-equipamento/{id}/ativar';

  /**
   * Ativar Tipo Equipamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarTipoEquipamento()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoEquipamento$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoEquipamentoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposEquipamentoService.AtivarTipoEquipamentoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoEquipamentoDto>;
      })
    );
  }

  /**
   * Ativar Tipo Equipamento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarTipoEquipamento$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoEquipamento(params: {
    id: number;
  }): Observable<TipoEquipamentoDto> {

    return this.ativarTipoEquipamento$Response(params).pipe(
      map((r: StrictHttpResponse<TipoEquipamentoDto>) => r.body as TipoEquipamentoDto)
    );
  }

  /**
   * Path part for operation desativarTipoEquipamento
   */
  static readonly DesativarTipoEquipamentoPath = '/tipos-equipamento/{id}/desativar';

  /**
   * Desativar TipoEquipamento.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarTipoEquipamento()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoEquipamento$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoEquipamentoDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposEquipamentoService.DesativarTipoEquipamentoPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoEquipamentoDto>;
      })
    );
  }

  /**
   * Desativar TipoEquipamento.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarTipoEquipamento$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoEquipamento(params: {
    id: number;
  }): Observable<TipoEquipamentoDto> {

    return this.desativarTipoEquipamento$Response(params).pipe(
      map((r: StrictHttpResponse<TipoEquipamentoDto>) => r.body as TipoEquipamentoDto)
    );
  }

}
